module.exports = __webpack_public_path__ + "img/avatar-s-7.5c809e07.jpg";